import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import {
  Grid,
  Box,
  Typography,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Button,
  Switch,
  Checkbox,
  FormControlLabel,
  IconButton,
  Modal,
  Snackbar,
  ListItemText,
  selectClasses,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import DownloadIcon from "@mui/icons-material/Download";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

import { getClassNames } from "./../../Js/Common";
import { createUser, updateUsersAction } from "./Services";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { map, findIndex } from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "#DB8829",
  borderRadius: 5,
  p: 4,
};

const ActionBar = (props) => {
  // Hooks
  const classes = useStyles();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  // State
  const [allClasses, setAllClasses] = useState([]);
  const [selectedClass, setselectedClass] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const [totalRecord, setTotalRecord] = useState(0);
  const [validRec, setValidRec] = useState(0);
  const [invalidRec, setInvalidRec] = useState(0);
  const [invalidRecArr, setInvalidRecArr] = useState([]);
  const [finalImportData, setFinalImportData] = useState([]);
  const [errorModal, setErrorModal] = useState(false);

  const [stateSnackbar, setStateSnackbar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = stateSnackbar;
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [certiFlag, setCertiFlag] = useState(false);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const serverRole = useSelector((state) => state.defs.serverRole);

  const handleChange = (event) => {
    setselectedClass(event.target.value);
    props.buttonAction(event.target.value);
  };

  // Add & Remove class from selection
  const handleSelectMultiple = (itemData) => {
    let newArray = [...selectedClass];
    let fndIndx = findIndex(selectedClass, { id: itemData.id });
    if (fndIndx === -1) {
      newArray.push(itemData);
    } else {
      newArray.splice(fndIndx, 1);
    }
    setselectedClass(newArray);
    props.buttonAction(newArray);
    localStorage.setItem("selectedClassIds",JSON.stringify(newArray));
    // if (newArray.length === trainers.length) {
    //   setIsCheckAll(true);
    // } else {
    //   setIsCheckAll(false);
    // }
  };

  useEffect(() => {
    dispatch(commonSliceActions.resetState());
    setAllChecked(props.userSelectionFlag);
  }, [props.userSelectionFlag]);

  useEffect(() => {
    const getInitialData = async () => {
      // console.log("userInfo====>", userInfo);

      console.log("props.rolesData", props.rolesData);
      if (
        props.rolesData &&
        props.rolesData.title.toLowerCase() === "learner"
      ) {
        let classData = await getClassNames(userInfo.site_uuid);
        console.log("allClasses", classData);
        setAllClasses(classData);
        if (classData.length > 0) {
          console.log(
            'localStorage.getItem("selectedClassIds")==>',
            localStorage.getItem("selectedClassIds")
          );
          if (localStorage.getItem("selectedClassIds")) {
            setselectedClass(JSON.parse(localStorage.getItem("selectedClassIds")));
            props.buttonAction(JSON.parse(localStorage.getItem("selectedClassIds")));
          } else {
            setselectedClass([classData[0]]);
            props.buttonAction([classData[0]]);
          }
        }
      }
    };
    getInitialData();
  }, [props.rolesData]);

  const selectAllChange = (e) => {
    setAllChecked(e.target.checked);
    props.userSelectionFlagAction(e.target.checked);
    if (e.target.checked === true) props.buttonAction("selectAll");
    else props.buttonAction("unSelectAll");
  };

  const handleFileChange = (e) => {
    let files = e.target.files;
    if (!files.length) return;
    let reader1 = new FileReader();
    let file = files[0];
    console.log("HERERE");
    reader1.readAsText(file);
    reader1.onload = loadHandler;
  };

  const loadHandler = async (e) => {
    let csv = e.target.result;
    let res = processData(csv);
    console.log("res", res);
    if (res.status === 500) {
      setSnackbarMessage(res.message);
      setStateSnackbar({ ...stateSnackbar, open: true });
      return;
    } else {
      setValidRec(res.validRecord);
      setInvalidRec(res.invalidRecord);
      setInvalidRecArr(res.invalidRecordArr);
      setFinalImportData(res.finalData);
      if (res.invalidRecordArr.length > 0) {
        console.log("res.invalidRecordArr", res.invalidRecordArr);
        setErrorModal(true);
      } else {
        addCsvData(res.finalData);
      }
    }
  };

  const processData = (csv) => {
    let allTextLines = csv.split(/\r\n|\n/);
    let tmpvalidRec = 0;
    let tmpinvalidRec = 0;
    let tmpinvalidRecArr = [];
    let tmpfinalImportData = [];

    setErrorModal(false);
    setTotalRecord(allTextLines.length - 2);

    let tableHeader = allTextLines[0].split(",");
    let allowedWebLogin = true;

    if (props.rolesData.title.toLowerCase() === "learner") {
      if (
        tableHeader[0] !== "GRNO" ||
        tableHeader[1] !== "FirstName*" ||
        tableHeader[2] !== "MiddleName" ||
        tableHeader[3] !== "LastName" ||
        tableHeader[4] !== "Gender*" ||
        tableHeader[5] !== "BirthDay" ||
        tableHeader[6] !== "BirthMonth" ||
        tableHeader[7] !== "BirthYear" ||
        tableHeader[8] !== "JoinDay" ||
        tableHeader[9] !== "JoinMonth" ||
        tableHeader[10] !== "JoinYear" ||
        tableHeader[11] !== "Rollno" ||
        tableHeader[12] !== "Class*" ||
        tableHeader[13] !== "Username*" ||
        tableHeader[14] !== "Password*"
      ) {
        return {
          status: 500,
          message: "header is not matching",
        };
      }

      if (serverRole !== "WEB_HOST") allowedWebLogin = false;

      for (let i = 1; i < allTextLines.length - 1; i++) {
        let data = allTextLines[i].split(",");
        let unm, pwd;
        unm = data[13].trim();
        pwd = data[14].trim();
        if (
          data[1] !== "" &&
          data[4] !== "" &&
          data[12] !== "" &&
          unm !== "" &&
          pwd !== ""
        ) {
          let gen = data[4].toLowerCase();
          if (gen !== "male" && gen !== "female") {
            tmpinvalidRec++;
            tmpinvalidRecArr.push("Record No." + i + ") Gender is Not Valid");
            continue;
          }
          let bdate, jdate, dt, mn, yr;
          if (!isValidDate(data[5], data[6], data[7])) {
            tmpinvalidRec++;
            tmpinvalidRecArr.push(
              "Record No." + i + ") Birth-Date is Not Valid"
            );
            continue;
          } else {
            dt = parseInt(data[5]) + 1;
            mn = parseInt(data[6]) - 1;
            yr = parseInt(data[7]);
            bdate = new Date(yr, mn, dt);
          }
          if (!isValidDate(data[8], data[9], data[10])) {
            tmpinvalidRec++;
            tmpinvalidRecArr.push(
              "Record No." + i + ") Join-Date is Not Valid"
            );
            continue;
          } else {
            dt = parseInt(data[8]) + 1;
            mn = parseInt(data[9]) - 1;
            yr = parseInt(data[10]);
            jdate = new Date(yr, mn, dt);
          }
          let stud_class = allClasses.find(function (obj) {
            return obj.value === data[12];
          });
          let class_id = "";
          if (stud_class === undefined) {
            tmpinvalidRec++;
            tmpinvalidRecArr.push("Record No." + i + ") Class is Not Valid");
            continue;
          } else {
            class_id = stud_class.id;
          }
          let json_to_send = {
            name: {
              firstname: data[1],
              middlename: data[2],
              lastname: data[3],
            },
            gr_no: parseInt(data[0]),
            gender: data[4],
            birthday: bdate,
            joining_date: jdate,
            belongs_to: class_id,
            roll_no: parseInt(data[11]),
            role_uid: props.rolesData.uid,
            username: unm,
            password: pwd,
            site_uuid: userInfo.site_uuid,
            allowedweblogin: allowedWebLogin,
          };
          tmpfinalImportData.push(json_to_send);
          tmpvalidRec++;
        } else {
          tmpinvalidRec++;
          tmpinvalidRecArr.push(
            "Record No." +
              i +
              ") FirstName, Gender, Class, Username & Password should not be empty"
          );
          continue;
        }
      }
      return {
        status: 200,
        message: "data is ok",
        validRecord: tmpvalidRec,
        invalidRecord: tmpinvalidRec,
        invalidRecordArr: tmpinvalidRecArr,
        finalData: tmpfinalImportData,
      };
    } else {
      if (
        tableHeader[0] !== "FirstName*" ||
        tableHeader[1] !== "MiddleName" ||
        tableHeader[2] !== "LastName" ||
        tableHeader[3] !== "Gender*" ||
        tableHeader[4] !== "BirthDay" ||
        tableHeader[5] !== "BirthMonth" ||
        tableHeader[6] !== "BirthYear" ||
        tableHeader[7] !== "JoinDay" ||
        tableHeader[8] !== "JoinMonth" ||
        tableHeader[9] !== "JoinYear" ||
        tableHeader[10] !== "Username*" ||
        tableHeader[11] !== "Password*" ||
        tableHeader[12] !== "Designation"
      ) {
        return {
          status: 500,
          message: "header is not matching",
        };
      }

      for (let i = 1; i < allTextLines.length - 1; i++) {
        let data = allTextLines[i].split(",");
        let unm, pwd;
        unm = data[10].trim();
        pwd = data[11].trim();
        if (data[0] !== "" && data[3] !== "" && unm !== "" && pwd !== "") {
          let gen = data[3].toLowerCase();
          if (gen !== "male" && gen !== "female") {
            tmpinvalidRec++;
            tmpinvalidRecArr.push("Record No." + i + ") Gender is Not Valid");
            continue;
          }
          let bdate, jdate, dt, mn, yr;
          if (!isValidDate(data[4], data[5], data[6])) {
            tmpinvalidRec++;
            tmpinvalidRecArr.push(
              "Record No." + i + ") Birth-Date is Not Valid"
            );
            continue;
          } else {
            dt = parseInt(data[4]) + 1;
            mn = parseInt(data[5]) - 1;
            yr = parseInt(data[6]);
            bdate = new Date(yr, mn, dt);
          }
          if (!isValidDate(data[7], data[8], data[9])) {
            tmpinvalidRec++;
            tmpinvalidRecArr.push(
              "Record No." + i + ") Join-Date is Not Valid"
            );
            continue;
          } else {
            dt = parseInt(data[7]) + 1;
            mn = parseInt(data[8]) - 1;
            yr = parseInt(data[9]);
            jdate = new Date(yr, mn, dt);
          }
          let json_to_send = {
            name: {
              firstname: data[0],
              middlename: data[1],
              lastname: data[2],
            },
            gender: data[3],
            birthday: bdate,
            joining_date: jdate,
            role_uid: props.rolesData.uid,
            username: unm,
            password: pwd,
            designation: data[12].trim(),
            site_uuid: userInfo.site_uuid,
            allowedweblogin: allowedWebLogin,
          };
          tmpfinalImportData.push(json_to_send);
          tmpvalidRec++;
        } else {
          tmpinvalidRec++;
          tmpinvalidRecArr.push(
            "Record No." +
              i +
              ") FirstName, Gender, Username & Password should not be empty"
          );
          continue;
        }
      }
      return {
        status: 200,
        message: "data is ok",
        validRecord: tmpvalidRec,
        invalidRecord: tmpinvalidRec,
        invalidRecordArr: tmpinvalidRecArr,
        finalData: tmpfinalImportData,
      };
    }
  };

  const addCsvData = async (data) => {
    console.log("HERE");
    //return;
    setErrorModal(false);
    let errRec = [];
    let unm = userInfo.username.split("@");
    let siteAlias = unm[1];
    console.log("finalImportData", data);

    for (let i = 0; i < data.length; i++) {
      let userRec = data[i];
      userRec.username = (userRec.username + "@" + siteAlias).toLowerCase();
      console.log("userRec", userRec);
      let rs = await createUser(userRec);
      console.log("createUser", rs);

      if (rs.status !== 200) {
        data[i].message = "Username already exists!";
        errRec.push(data[i]);
      }
    }
    console.log("errRec", errRec);
    if (errRec.length > 0) {
      console.log("Errors in following record ", errRec.length);
      setSnackbarMessage("Errors in following record");
      setStateSnackbar({ ...stateSnackbar, open: true });
      download_err_template(errRec);
    }
    if (errRec.length < data.length) {
      setSnackbarMessage("CSV uploaded suceessfully!");
      setStateSnackbar({ ...stateSnackbar, open: true });
    }
  };

  const download_err_template = (errRec) => {
    let csv = "";
    if (props.rolesData.title.toLowerCase() === "learner")
      csv = "No,Name,Class,Username,Error Message\n";
    else csv = "No,Name,Username,Error Message\n";
    for (let t = 0; t < errRec.length; t++) {
      let tmp = errRec[t];
      let nm =
        tmp["name"]["firstname"] +
        " " +
        tmp["name"]["middlename"] +
        " " +
        tmp["name"]["lastname"];
      let no = t + 1;
      if (props.rolesData.title.toLowerCase() === "learner") {
        console.log("this.classNames", allClasses);
        let cls = allClasses.find(function (obj) {
          return obj.id === tmp["belongs_to"];
        });
        console.log("cls", cls);
        csv =
          csv +
          no +
          "," +
          nm +
          "," +
          cls.value +
          "," +
          tmp["username"] +
          "," +
          tmp["message"];
      } else {
        csv =
          csv + no + "," + nm + "," + tmp["username"] + "," + tmp["message"];
      }
      csv += "\n";
    }
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute("download", "error.csv");
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  const downloadErr = () => {
    console.log("invalidRecArr", invalidRecArr);
    let textData = invalidRecArr;
    let link = document.createElement("a");
    link.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(textData)
    );
    link.download = "err.txt";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isValidDate = (day, month, year) => {
    day = parseInt(day);
    month = parseInt(month);
    year = parseInt(year);
    // if(isNaN(day) || isNaN(month) || isNaN(year)){
    //   return false;
    // }
    if (month < 1 || month > 12) {
      // check month range
      return false;
    }
    if (day < 1 || day > 31) {
      return false;
    }
    if (
      (month === 4 || month === 6 || month === 9 || month === 11) &&
      day === 31
    ) {
      return false;
    }
    if (month === 2) {
      // check for february 29th
      let isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
      if (day > 29 || (day === 29 && !isleap)) {
        return false;
      }
    }
    let d = new Date();
    let currentYear = d.getFullYear();
    if (year > currentYear) {
      return false;
    }
    return true; // date is valid
  };

  const promoteDownloadTemplate = () => {
    let licenseAlias = userInfo.username.split("@");
    let aliasName = licenseAlias[1].toLowerCase();
    let csv = "";
    csv =
      "FirstName*,LastName,UserName*,Current(from)Class*,Promote(to)Class*\n";
    let nm, lnm, unm, fromClass, toClass;
    nm = "Jay";
    lnm = "Roy";
    for (let t = 0; t < allClasses.length; t++) {
      unm = nm + t + "@" + aliasName;
      fromClass = allClasses[t].value;
      if (t === allClasses.length - 1) {
        toClass = allClasses[0].value;
      } else {
        toClass = allClasses[t + 1].value;
      }
      csv =
        csv +
        nm +
        "," +
        lnm +
        "," +
        unm.toLowerCase() +
        "," +
        fromClass +
        "," +
        toClass;
      csv += "\n";
    }
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute("download", "promote.csv");
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  const promoteFileChange = (e) => {
    let files = e.target.files;
    if (!files.length) return;
    let reader1 = new FileReader();
    let file = files[0];
    console.log("HERERE");
    reader1.readAsText(file);
    reader1.onload = promoteFileUpload;
  };

  const promoteFileUpload = async (e) => {
    let csv = e.target.result;
    let allTextLines = csv.split(/\r\n|\n/);
    let tmpvalidRec = 0;
    let tmpinvalidRec = 0;
    let tmpinvalidRecArr = [];
    let tmpfinalImportData = [];

    setErrorModal(false);
    setTotalRecord(allTextLines.length - 2);

    let tableHeader = allTextLines[0].split(",");
    if (
      tableHeader[0] !== "FirstName*" ||
      tableHeader[1] !== "LastName" ||
      tableHeader[2] !== "UserName*" ||
      tableHeader[3] !== "Current(from)Class*" ||
      tableHeader[4] !== "Promote(to)Class*"
    ) {
      setSnackbarMessage("header is not matching");
      setStateSnackbar({ ...stateSnackbar, open: true });
      return;
    }

    for (let i = 1; i < allTextLines.length - 1; i++) {
      let data = allTextLines[i].split(",");
      console.log("data====", data);
      if (
        data[0] !== "" &&
        data[2] !== "" &&
        data[3] !== "" &&
        data[4] !== ""
      ) {
        let findObj = allClasses.find((obj) => {
          return obj.value === data[4];
        });
        console.log("findObj", findObj);
        if (findObj === undefined) {
          tmpinvalidRec++;
          tmpinvalidRecArr.push(
            "Record No." + i + ") Promote(to)Class is Not Valid"
          );
          continue;
        }

        let json_to_send = {
          username: data[2].trim(),
          classId: findObj.id,
        };
        tmpfinalImportData.push(json_to_send);
        tmpvalidRec++;
      } else {
        tmpinvalidRec++;
        tmpinvalidRecArr.push(
          "Record No." +
            i +
            ") FirstName, Username, Current(from)Class & Promote(to)Class"
        );
        continue;
      }
    }
    setValidRec(tmpvalidRec);
    setInvalidRec(tmpinvalidRec);
    setInvalidRecArr(tmpinvalidRecArr);
    setFinalImportData(tmpfinalImportData);
    if (tmpinvalidRecArr.length > 0) {
      setErrorModal(true);
    } else {
      promoteUserData(tmpfinalImportData);
      setSnackbarMessage("User Promoted Successfully...");
      setStateSnackbar({ ...stateSnackbar, open: true });
    }
  };

  const promoteUserData = async (data) => {
    let uniqueClassId = [...new Set(data.map((item) => item.classId))];
    console.log("data", data);
    console.log("uniqueClassId", uniqueClassId);
    for (let i = 0; i < uniqueClassId.length; i++) {
      let result = data.filter((val, index) => {
        if (val.classId === uniqueClassId[i]) {
          return val.username;
        }
      });
      let userNameArr = [...new Set(result.map((item) => item.username))];
      if (userNameArr.length > 0) {
        let data = {};
        data.belongs_to = uniqueClassId[i];
        data.is_synced = false;
        let params = {
          query: {
            username: userNameArr,
            site_uuid: userInfo.site_uuid,
          },
        };
        let response = await updateUsersAction(null, data, params);
        console.log("respomse======", response);
      }
    }
  };

  const handleClose = () => {
    setStateSnackbar({ ...stateSnackbar, open: false });
  };

  return (
    <Box>
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid item>
          {props.rolesData &&
            props.rolesData.title.toLowerCase() === "learner" && (
              <FormControl sx={{ m: 1, minWidth: 120, maxWidth: 180 }} size="small">
                <InputLabel
                  sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}
                >
                  Class
                </InputLabel>
                <Select
                  multiple
                  autoWidth
                  value={selectedClass}
                  label="Class"
                  renderValue={(selected) => {
                    return map(selected, "value").join(", ");
                  }}
                  sx={{
                    borderRadius: 10,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  {allClasses &&
                    allClasses.map((obj, ind) => {
                      return (
                        <MenuItem
                          key={`${ind}_class`}
                          value={obj.id}
                          sx={{
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                            },
                          }}
                          onClick={() => handleSelectMultiple(obj)}
                        >
                          <Checkbox
                            checked={
                              selectedClass.filter((item) => item.id === obj.id)
                                .length > 0
                            }
                          />
                          <ListItemText primary={obj.value} />
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            )}
        </Grid>

        <Grid item>
          <Box sx={{ width: "100%", typography: "body1", textAlign: "center" }}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {serverRole == "WEB_HOST" &&
                userInfo.rolesInfo.title.toLowerCase() == "admin" &&
                props.rolesData &&
                props.rolesData.title.toLowerCase() === "learner" && (
                  <Grid item>
                    <WorkspacePremiumIcon
                      sx={{ fontSize: "2vw", color: "#DB8829", pt: 1, pr: 1 }}
                      onClick={() => {
                        dispatch(
                          commonSliceActions.setParamsData({
                            rolesData: props.rolesData,
                            selectedClass: selectedClass,
                            allClasses: allClasses,
                            tabValue: props.rolesData.title.toLowerCase(),
                          })
                        );
                        navigation(`/Users/LearnersCertificates`);
                      }}
                    />
                  </Grid>
                )}
              {((serverRole == "WEB_HOST" &&
                userInfo.rolesInfo.title.toLowerCase() == "admin") ||
                (serverRole != "WEB_HOST" &&
                  userInfo.rolesInfo.title.toLowerCase() == "incharge")) && (
                <Grid item>
                  <Button
                    sx={{
                      color: "#5f5600ff",
                      backgroundColor: "#F5F5F5",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      borderRadius: 10,
                      px: 1,
                      py: 1.2,
                      
                      "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                    }}
                    onClick={() => {
                      dispatch(
                        commonSliceActions.setParamsData({
                          rolesData: props.rolesData,
                          userUid: null,
                          tabValue: props.rolesData.title.toLowerCase(),
                        })
                      );
                      navigation(`/Users/Add/`);
                    }}
                  >
                    Add
                  </Button>
                </Grid>
              )}

              {props.rolesData &&
                props.rolesData.title.toLowerCase() === "trainer" && (
                  <Grid item>
                    <Button
                      sx={{
                        color: "#5f5600ff",
                        backgroundColor: "#F5F5F5",
                        fontWeight: "600",
                        fontSize: "0.8rem",
                        mx: 1,
                        borderRadius: 10,
                        px: 1,
                        py: 1.2,
                       
                        "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                      }}
                      onClick={() => {
                        dispatch(
                          commonSliceActions.setParamsData({
                            rolesData: props.rolesData,
                            tabValue: props.rolesData.title.toLowerCase(),
                          })
                        );
                        navigation(`/Users/AssignTrainersClass`);
                      }}
                    >
                      Assign Class
                    </Button>
                  </Grid>
                )}

              {props.rolesData &&
                props.rolesData.title.toLowerCase() === "learner" &&
                userInfo.rolesInfo.title.toLowerCase() == "admin" && (
                  <>
                    <Grid item sx={{ px: 1 }}>
                      <Button
                        sx={{
                          color: "#5f5600ff",
                          backgroundColor: "#F5F5F5",
                          fontWeight: "600",
                          fontSize: "0.8rem",
                          borderRadius: 10,
                          px: 1,
                          py: 1.2,
                         
                          "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                        }}
                        onClick={() => {
                          dispatch(
                            commonSliceActions.setParamsData({
                              rolesData: props.rolesData,
                              tabValue: props.rolesData.title.toLowerCase(),
                            })
                          );
                          navigation(`/Users/MoveLearners`);
                        }}
                      >
                        LC Issued
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        sx={{
                          color: "#5f5600ff",
                          backgroundColor: "#F5F5F5",
                          fontWeight: "600",
                          fontSize: "0.8rem",
                          borderRadius: 10,
                          px: 1,
                          py: 1.2,
                         
                          "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                        }}
                        onClick={() => {
                          dispatch(
                            commonSliceActions.setParamsData({
                              rolesData: props.rolesData,
                              tabValue: props.rolesData.title.toLowerCase(),
                            })
                          );
                          navigation(`/Users/MoveLearners`);
                        }}
                      >
                        Move
                      </Button>
                    </Grid>
                    <Grid item sx={{ pl: 1 }}>
                      <Grid
                        container
                        sx={{
                          alignItems: "center",
                          color: "#5f5600ff",
                          backgroundColor: "#F5F5F5",
                          fontWeight: "600",
                          fontSize: "0.8rem",
                          borderRadius: 10,
                          px: 1,
                          py: 0.3,
                          "@media (min-width: 1636px)": { fontSize: "1.2rem" },
                        }}
                      >
                        <Grid>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              fontSize: "0.82rem",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                          >
                            Promote
                          </Typography>
                        </Grid>
                        <Grid item sx={{ px: 1 }}>
                          <Box>
                            <IconButton
                              aria-label="comment"
                              color="primary"
                              sx={{ padding: 0 }}
                              onClick={promoteDownloadTemplate}
                            >
                              <CloudDownloadIcon sx={{ fontSize: "1.5vw" }} />
                            </IconButton>
                          </Box>
                          <Box sx={{ m: 0, p: 0 }}>
                            <Typography
                              sx={{
                                fontSize: "0.5rem",
                                color: "#5f5600ff",
                                fontWeight: "600",
                                "@media (min-width: 1636px)": {
                                  fontSize: "0.8rem",
                                },
                              }}
                            >
                              Download
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item sx={{}}>
                          <Box>
                            <IconButton
                              aria-label="comment"
                              color="primary"
                              sx={{ padding: 0 }}
                              onClick={() => {
                                document
                                  .getElementById("promotecsvfile")
                                  .click();
                              }}
                            >
                              <CloudUploadIcon sx={{ fontSize: "1.5vw" }} />
                            </IconButton>
                          </Box>
                          <input
                            type="file"
                            id="promotecsvfile"
                            name="promotecsvfile"
                            style={{ display: "none" }}
                            onChange={promoteFileChange}
                          ></input>
                          <Box sx={{ m: 0, p: 0 }}>
                            <Typography
                              sx={{
                                fontSize: "0.5rem",
                                color: "#5f5600ff",
                                fontWeight: "600",
                                "@media (min-width: 1636px)": {
                                  fontSize: "0.8rem",
                                },
                              }}
                            >
                              Upload
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}

              <Grid item>
                <Box
                  sx={{
                    color: "#5f5600ff",
                    backgroundColor: "#F5F5F5",
                    fontWeight: "600",
                    fontSize: "0.82rem",
                    mx: 1,
                    borderRadius: 10,
                    px: 1,
                    py: 0.3,
                   
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Active
                  <Switch
                    checked={isActive}
                    size="small"
                    inputProps={{ "aria-label": "controlled" }}
                    color="primary"
                    onChange={() => {
                      setIsActive(!isActive);
                    }}
                  />
                  <IconButton
                    onClick={() => {
                      if (isActive === true)
                        props.buttonAction("downloadActiveUsers");
                      else props.buttonAction("downloadInActiveUsers");
                    }}
                  >
                    <DownloadIcon sx={{ fontSize: "1.6vw" }} />
                  </IconButton>
                </Box>
              </Grid>
              {((serverRole == "WEB_HOST" &&
                userInfo.rolesInfo.title.toLowerCase() == "admin") ||
                (serverRole != "WEB_HOST" &&
                  userInfo.rolesInfo.title.toLowerCase() == "incharge")) && (
                <>
                  <Grid item>
                    <Box>
                      <IconButton
                        aria-label="comment"
                        color="primary"
                        sx={{ padding: 0 }}
                        onClick={() => {
                          props.buttonAction("downloadTemplate");
                        }}
                      >
                        <CloudDownloadIcon sx={{ fontSize: "1.5vw" }} />
                      </IconButton>
                    </Box>
                    <Box sx={{ m: 0, p: 0 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#5f5600ff",
                          fontWeight: "600",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                          },
                        }}
                      >
                        Download <br /> Template
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item sx={{ pl: 1 }}>
                    <Box>
                      <IconButton
                        aria-label="comment"
                        color="primary"
                        sx={{ padding: 0 }}
                        onClick={() => {
                          document.getElementById("csvfile").click();
                        }}
                      >
                        <CloudUploadIcon sx={{ fontSize: "1.5vw" }} />
                      </IconButton>
                    </Box>
                    <input
                      type="file"
                      id="csvfile"
                      name="csvfile"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    ></input>
                    <Box sx={{ m: 0, p: 0 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#5f5600ff",
                          fontWeight: "600",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                          },
                        }}
                      >
                        Import <br /> Users
                      </Typography>
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>

      {((serverRole == "WEB_HOST" &&
        userInfo.rolesInfo.title.toLowerCase() == "admin") ||
        (serverRole != "WEB_HOST" &&
          userInfo.rolesInfo.title.toLowerCase() == "incharge")) && (
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            boxShadow: 2,
            borderRadius: 5,
            mt: 2,
            py: 2,
          }}
        >
          <Grid item>
            <FormControlLabel
              sx={{ pl: 3 }}
              control={
                <Checkbox
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CircleIcon />}
                  checked={allChecked}
                  onClick={selectAllChange}
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: "1.6rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.8rem",
                      },
                    },
                  }}
                />
              }
              label={
                <Typography
                  color="textSecondary"
                  sx={{
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  Select All
                </Typography>
              }
            ></FormControlLabel>
          </Grid>

          <Grid item>
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Grid item>
                <Button
                  sx={{
                    color: "#5f5600ff",
                    backgroundColor: "#F5F5F5",
                    fontWeight: "600",
                    mr: 2,
                    borderRadius: 10,
                    px: 2,
                  
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}
                  onClick={() => {
                    props.buttonAction("activeWebLogin");
                  }}
                >
                  Active Web Login
                </Button>
              </Grid>

              <Grid item>
                <Button
                  sx={{
                    color: "#5f5600ff",
                    backgroundColor: "#F5F5F5",
                    fontWeight: "600",
                    mr: 2,
                    borderRadius: 10,
                    px: 2,
                   
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}
                  onClick={() => {
                    props.buttonAction("inActiveWebLogin");
                  }}
                >
                  InActive Web Login
                </Button>
              </Grid>

              <Grid item>
                <Button
                  sx={{
                    color: "#5f5600ff",
                    backgroundColor: "#F5F5F5",
                    fontWeight: "600",
                    mr: 2,
                    borderRadius: 10,
                    px: 2,
                   
                    "@media (min-width: 1636px)": {
                      fontSize: "1.2rem",
                    },
                  }}
                  onClick={() => {
                    props.buttonAction("delete");
                  }}
                >
                  Delete
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={6000}
        open={open}
        onClose={handleClose}
        message={snackbarMessage}
        key={vertical + horizontal}
        ContentProps={{
          classes: {
            root: classes.root,
          },
        }}
        sx={{ top: { xs: 90, sm: 0 } }}
      />

      <Modal open={errorModal}>
        <Box sx={{ ...style }}>
          <Typography
            sx={{
              fontSize: "1.8rem",
              fontWeight: "800",
              color: "#FFFFFF",
              borderBottom: 4,
              borderColor: "#EAECEE",
              "@media (min-width: 1636px)": {
                fontSize: "2.8rem",
              },
            }}
          >
            File Errors
          </Typography>
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              my: 2,
            }}
          >
            <Grid item xs={8}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.8rem",
                  },
                }}
              >
                Total Records:
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.8rem",
                  },
                }}
              >
                {" "}
                {totalRecord}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Grid item xs={8}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.8rem",
                  },
                }}
              >
                Valid Records:
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.8rem",
                  },
                }}
              >
                {" "}
                {validRec}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Grid item xs={8}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.8rem",
                  },
                }}
              >
                Invalid Records:
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.8rem",
                  },
                }}
              >
                {" "}
                {invalidRec}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton
                sx={{ flexWrap: "wrap", mt: 1 }}
                onClick={downloadErr}
              >
                <DownloadForOfflineIcon
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "1.6rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "2.4rem",
                    },
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: "#FFFFFF",
                    fontWeight: "500",
                    "@media (min-width: 1636px)": {
                      fontSize: "1rem",
                    },
                  }}
                >
                  Download
                </Typography>
              </IconButton>
            </Grid>
          </Grid>
          <Typography
            sx={{
              color: "#FFFFFF",
              fontSize: "1.4rem",
              fontWeight: "600",
              textAlign: "center",
              py: 1,
              "@media (min-width: 1636px)": {
                fontSize: "2.4rem",
              },
            }}
          >
            Save Valid Records?
          </Typography>

          <Box sx={{ my: 3, mx: 4 }}>
            <Button
              variant="standard"
              fullWidth
              sx={{
                color: "#FFFFFF",
                fontSize: "1.2rem",
                fontWeight: "700",
                border: 1,
                borderColor: "#FFFFFF",
                borderRadius: 10,
               
                "@media (min-width: 1636px)": {
                  fontSize: "1.8rem",
                },
              }}
              onClick={() => {
                addCsvData(finalImportData);
              }}
            >
              yes
            </Button>
          </Box>
          <Box sx={{ mx: 4 }}>
            <Button
              variant="standard"
              fullWidth
              sx={{
                color: "#FFFFFF",
                fontSize: "1.2rem",
                fontWeight: "700",
                border: 1,
                borderColor: "#FFFFFF",
                borderRadius: 10,
               
                "@media (min-width: 1636px)": {
                  fontSize: "1.8rem",
                },
              }}
              onClick={() => setErrorModal(false)}
            >
              no
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
const useStyles = makeStyles({
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      width: "0.0em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default ActionBar;
